import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import MTable from "../../../../components/mtable"
import Title from "../../../../components/Title"
import { api } from "../../../../env"
import { handleError } from "../../../../utils/errors/errorHandler"

const formatList = (items) => new Intl.ListFormat('en', { style: 'long', type: 'conjunction' }).format(items)

export default function ManageCompanyTracks() {
    const { id: companyId } = useParams()
    const navigate = useNavigate()
    const [companyTrackIds, setCompanyTrackIds] = useState([])
    const [added, setAdded] = useState([])
    const [removed, setRemoved] = useState([])
    const [saving, setSaving] = useState(false)

    useEffect(() => {
        api.get(`/companies/${companyId}/tracks/ids`)
            .then(res => setCompanyTrackIds(res.data))
    }, [companyId])

    const handleSelection = (selectedItems) => {
        const selectedIds = selectedItems.map(i => i.id)
        setAdded(selectedIds.filter(id => !companyTrackIds.includes(id)))
        setRemoved(companyTrackIds.filter(id => !selectedIds.includes(id)))
    }

    const save = () => {
        setSaving(true)
        // Errors are toasted here instead of by the interceptor, so the 409 can name the tracks
        api.put(`/companies/${companyId}/tracks/access`, { added, removed }, { suppressErrorToast: true })
            .then(() => navigate(-1))
            .catch(err => {
                // The backend wraps error bodies: { statusCode, message: { message, code, object } }
                const body = err.response?.data?.message
                if (err.response?.status === 409 && body?.code === 'TRACK_IN_USE_BY_PROGRAM') {
                    const names = (body.object ?? []).map(t => t.displayName ?? t.id)
                    handleError(`Can't remove access to ${formatList(names)}. ${names.length === 1 ? "It's" : "They're"} still used in this company's programs.`)
                } else {
                    handleError(body ?? "Couldn't save track access")
                }
                setSaving(false)
            })
    }

    const mapper = { columns: [
        { label: "Name", value: (item) => item.name },
        { label: "Display Name", value: (item) => item.displayName },
        { label: "Status", value: (item) => item.status }
    ]}

    return (
        <div className="page-xl-centered standard-padding showing">
            <div className="flex space-between center gap-xs v-spacer-m">
                <Title>Manage Track Access</Title>
                <button className={`solid ${saving ? 'disabled' : ''}`} disabled={saving} onClick={save}>Save</button>
            </div>
            <MTable
                path={'tracks'}
                queryParams={{ status: 'Published' }}
                mapper={mapper}
                selectable={{
                    onChange: handleSelection,
                    multiple: true,
                    preselected: companyTrackIds.map(id => ({ id }))
                }}
            />
        </div>
    )
}